<!-- Global drop list / columns -->
<div
  *ngrxLet="kanbanBoardStore.isColumnNameInputVisible$ as isColumnNameInputVisible"
  class="column-wrapper"
  cdkDropListGroup
  cdkDropList
  (cdkDropListDropped)="columnDrop($event)"
  [cdkDropListOrientation]="'horizontal'"
  [cdkDropListAutoScrollStep]="horizontalScrollPixels"
  #columnWrapper
  cdkScrollable
>
  <!-- Specific column / drop list for installation -->
  <div
    *ngFor="let column of columns; index as columnIndex; trackBy: trackByColumn"
    #columnElement
    [class.column-no-scroll]="isDraggingColumn"
    [class.column-with-cover]="
      isDraggingInstallation && columnIndex !== indexOfColumnOfDraggedInstallation
    "
    class="column"
    cdkDrag
    cdkDragLockAxis="x"
    cdkDragPreviewClass="column-preview"
    cdkDragPreviewContainer="parent"
    (cdkDragStarted)="columnDragStart()"
    (cdkDragEnded)="columnDragStop()"
    (cdkDragMoved)="handleDragEvent($event)"
    cdkDropList
    cdkDropListSortingDisabled="true"
    [cdkDropListAutoScrollStep]="horizontalScrollPixels"
    [cdkDropListData]="{ column }"
    (cdkDropListDropped)="installationDrop($event)"
    [attr.data-at-column-name]="column.name"
  >
    <!-- Covering element for installation d&d -->
    <div
      *ngIf="
        isDraggingInstallation &&
        columnIndex !== indexOfColumnOfDraggedInstallation &&
        idOfDraggedInstallation
      "
      class="column__cover"
    >
      <app-kanban-column-drop-cover
        [column]="column"
        [idOfDraggedInstallation]="idOfDraggedInstallation"
        (mouseenter)="setIsColumnHovered(true)"
        (mouseleave)="setIsColumnHovered(false)"
      ></app-kanban-column-drop-cover>
    </div>
    <!-- Dynamic column header -->
    <div
      class="column__header"
      [class.column__header--installation-drag]="isDraggingInstallation"
      [class.column__header--input]="column.inputShowed"
      cdkDragHandle
      [cdkDragHandleDisabled]="isColumnNameInputVisible"
    >
      <div
        class="column__header__name"
        [class.column__header__name--dragged-installation]="
          columnIndex === indexOfColumnOfDraggedInstallation
        "
        (click)="toggleColumnNameInput(column)"
      >
        <!-- Header input -->
        <app-kanban-column-name-input
          [column]="column"
          [allColumnNames]="kanbanBoardStore.allColumnNames$ | async"
          *ngIf="column.inputShowed"
        ></app-kanban-column-name-input>
        <!-- Header readonly -->
        <ng-container *ngIf="!column.inputShowed">
          <span class="column__header__title"> {{ column.name | kanbanColumnName }} </span>
          <span> - {{ column.installations.length }}</span>
          <span> ({{ column.installationIds.length }})</span>
        </ng-container>
      </div>
      <app-kanban-column-menu
        *ngIf="!column.inputShowed"
        [column]="column"
      ></app-kanban-column-menu>
    </div>
    <!-- Installation tiles -->
    <div
      class="column__tiles"
      [class.column-fill-height]="
        (isDraggingInstallation && columnIndex === indexOfColumnOfDraggedInstallation) ||
        isDraggingColumn
      "
      [class.list-padding]="isDraggingInstallation"
      [class.list-margin]="isDraggingColumn"
      [class.column__tiles--hidden]="
        isDraggingInstallation && columnIndex !== indexOfColumnOfDraggedInstallation
      "
      #columnTiles
      (scroll)="onScroll($event, column)"
    >
      <ng-container
        *ngFor="
          let installation of column.installations;
          let i = index;
          trackBy: trackByInstallation
        "
      >
        <ng-container *ngIf="installation">
          <app-kanban-installation-list-tile
            #tile
            [installation]="installation"
            [isColumnSelfDefined]="column.selfDefined"
            [columnId]="column.id"
            [columnIndex]="columnIndex"
            cdkDrag
            [attr.data-index]="i"
            cdkDragPreviewClass="tile-preview"
            (mousedown)="setColumnScrollTop(columnTiles.scrollTop)"
            [cdkDragPreviewContainer]="columnWrapper"
            (cdkDragStarted)="installationDragStart(columnIndex, installation.id)"
            (cdkDragEnded)="installationDragStop()"
            (cdkDragMoved)="handleDragEvent($event)"
            [cdkDragDisabled]="isColumnNameInputVisible"
          ></app-kanban-installation-list-tile>
          <!-- Placeholder created by library is hidden, component below is displayed instead -->
          <!-- When it's rendered scroll down column to the state before drag&drop start -->
          <app-kanban-installation-list-tile
            *ngIf="
              columnIndex === indexOfColumnOfDraggedInstallation &&
              installation.id === idOfDraggedInstallation
            "
            appLifecycleHooksHandler
            (emitAfterViewInit)="scrollColumn(columnTiles, tile.componentClientHeight)"
            class="greyed-installation"
            [installation]="installation"
            [isColumnSelfDefined]="column.selfDefined"
            [columnId]="column.id"
            [columnIndex]="columnIndex"
          ></app-kanban-installation-list-tile>
        </ng-container>
      </ng-container>
      <vi-loader [isLoading]="true" message="" *ngIf="column.loading"></vi-loader>
    </div>
  </div>
  <!-- New column section -->
  <div class="column" *ngIf="!(kanbanBoardStore.isTempColumn$ | async)">
    <div
      *ngrxLet="kanbanBoardStore.selectIsLimitOfSelfDefinedColumnsHit$ as columnLimitHit"
      class="add-column-tile"
    >
      <div
        [matTooltip]="
          columnLimitHit
            ? ('+INSTALLATIONS.KANBAN_DASHBOARD.INSTALLATION_MANAGE.DISABLE_CREATE_NEW_COLUMN'
              | translate: { limit: limitOfSelfDefinedColumns })
            : null
        "
      >
        <button
          [disabled]="columnLimitHit"
          class="add-button"
          mat-button
          stroked-button
          color="primary"
          (click)="addNewColumn()"
        >
          <mat-icon>add_circle</mat-icon>
          <span> {{ '+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.ADD_COLUMN' | translate }} </span>
        </button>
      </div>
    </div>
  </div>
</div>
